import { SPRYKER_COMMERCE_CONNECTOR_PATH } from '../constants';
import { CommerceConnectorHandler } from '../types/api-params/commerceConnector';
import { CommerceConnectorApi } from '../types/api/commerce-connector-api';
import { NetworkResponse } from '../types/services/request.types';
import { RequestHandler } from './requestHandler.service';
import { UrlBuilder } from './urlBuilder.service';

export class SprykerCommerceConnectorHandler extends RequestHandler {
  api = {
    target: 'spryker-commerce-connector',
    default: 'spryker-default',
  };

  getCommerceConnector(
    parameters: CommerceConnectorHandler,
  ): NetworkResponse<CommerceConnectorApi.GetCommerceConnectorResponse> {
    if (typeof parameters.url === 'string') {
      return this.get<CommerceConnectorApi.GetCommerceConnectorResponse>(
        parameters.url,
      );
    }

    return this.get<CommerceConnectorApi.GetCommerceConnectorResponse>(
      UrlBuilder.buildSprykerURL({
        ...parameters.url,
        endPointName: SPRYKER_COMMERCE_CONNECTOR_PATH,
      }),
    );
  }
}

export const SprykerCommerceConnector = new SprykerCommerceConnectorHandler();
